import Box from "@mui/material/Box";

const ThemableImage = ({ src, height, ...otherProps }: { src: string; height: string }) => {
  return <Box component="img" src={src} sx={{ height, display: { xs: "none", md: "block" } }} {...otherProps} alt="image1" />;
};

export default ThemableImage;
